import OpenInNew from '@mui/icons-material/OpenInNew';
import { MessagingChannelTargetType } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { SmallLoadingButton } from '~components/Order/ordersDispatchStyledComponents';
import {
  isMessagingChannelTargetReference,
  MessagingChannel,
  MessagingChannelTargetReference,
} from '~hooks/useMessaging/models';
import { useOpenMessagingChannelTarget } from '~pages/Messages/useOpenMessagingChannelTarget';

const OPEN_TARGET_LABEL_KEYS = {
  [MessagingChannelTargetType.JOB]: 'messaging.open_job',
  [MessagingChannelTargetType.ORDER]: 'messaging.open_order',
} satisfies Record<MessagingChannelTargetType, string>;

type MessagingChannelTargetButtonProps = {
  channel: MessagingChannel;
};

const OpenTargetButton = ({ target }: { target: MessagingChannelTargetReference }) => {
  const { isOpening, openTarget } = useOpenMessagingChannelTarget(target);

  return (
    <SmallLoadingButton
      color="brandV2Black"
      data-test-id="messaging-open-target"
      loading={isOpening}
      onClick={openTarget}
      startIcon={<OpenInNew sx={{ fontSize: 16 }} />}
      sx={{
        '&:hover': { backgroundColor: 'action.hover' },
        borderColor: 'divider',
        color: 'text.primary',
        flexShrink: 0,
      }}
      variant="outlined"
    >
      {t(OPEN_TARGET_LABEL_KEYS[target.type])}
    </SmallLoadingButton>
  );
};

const MessagingChannelTargetButton = ({ channel }: MessagingChannelTargetButtonProps) => {
  const { target } = channel;
  if (!target || !isMessagingChannelTargetReference(target)) {
    return null;
  }

  return <OpenTargetButton key={channel.id} target={target} />;
};

export default MessagingChannelTargetButton;
